module.exports = {
    URLAPI: 'https://wpstrapi.sotertec.com.br/api',
    urlReact: 'https://somaassist.com.br',
    CLIENT: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRlX2lkIjoiYWM2ZTgxM2EtZDM0MC00MDU5LWE1ZWMtMWU2MDQxYjEzNWI5IiwiaWF0IjoxNzU3NjIxMjYzfQ.aOyjgxWTh3OI4WrN7ryMkblniboKHQWgcWntNz1LbEE'
}